import ApiHeaders from '@/datatypes/api-headers';

export default class ApiOptions {
  public method;
  public url;
  public baseURL;
  public headers: ApiHeaders;
  public data;
  public params;

  constructor(options) {
    this.method = options.method;
    this.url = options.url;
    this.baseURL = options.baseURL;
    this.headers = options.headers;
    this.data = options.data;
    this.params = options.params;
    this.setDefaults();
  }

  setHeaders(headers: ApiHeaders) {
    this.headers = headers;
  }

  private setDefaults() {
    if (typeof this.method === 'undefined') {
      this.method = 'get';
    }
    if (typeof this.baseURL === 'undefined') {
      this.baseURL = process.env.VUE_APP_API_URL;
    }
  }

  public render() {
    return {
      method: this.method,
      url: this.url,
      baseURL: this.baseURL,
      headers: this.headers.render(),
      data: this.data,
      params: this.params,
    };
  }
}
